import React, { useState } from 'react';
import { Button, Form, Col, Row, Badge, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import projectBusinessUnitsService from '../services/project_report/project_business_units.service';
import BusinessUnitModal from './BusinessUnitModal';
import businessUnitsService from '../services/business_unit.service';
import BusinessUnitItem from './BusinessUnitItem';
import ImmutableUnderReviewFormControl from '../util/reviewEditControls/ImmutableUnderReviewFormControl';
const BusinessUnitsSection = _ref => {
  let {
    report,
    setReport,
    claimGroup,
    pageAccess,
    isUnderReview,
    onAdd,
    onRemove,
    labelColSpan = 4,
    displayOnly = false
  } = _ref;
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState(null);
  const {
    t
  } = useTranslation();
  const [modalShow, setModalShow] = useState(false);
  const handleChange = e => {
    if (+e.target.value === 0) {
      setModalShow(true);
    } else {
      setSelectedBusinessUnit(+e.target.value);
    }
  };
  const submit = async () => {
    if (onAdd) {
      return onAdd(report, report.business_units.find(bu => bu.id === selectedBusinessUnit));
    }
    const newProjectBusinessUnit = await projectBusinessUnitsService.create(report.id, {
      business_unit_id: selectedBusinessUnit
    });
    setSelectedBusinessUnit(null);
    setReport({
      ...report,
      project_business_units: [...report.project_business_units, newProjectBusinessUnit]
    });
  };
  const handleDelete = async id => {
    await projectBusinessUnitsService.delete(report.id, id);
    const newProjectBusinessUnits = report.project_business_units.filter(pbu => pbu.id !== id);
    setReport({
      ...report,
      project_business_units: newProjectBusinessUnits
    });
  };
  const handleCreateBusinessUnit = async businessUnit => {
    const newBusinessUnit = await businessUnitsService.create(claimGroup.company_id, businessUnit);
    setReport({
      ...report,
      business_units: [...report.business_units, newBusinessUnit]
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BusinessUnitModal, {
    className: "BusinessUnitsSection",
    title: 'Create Business Unit',
    onHide: () => setModalShow(false),
    show: modalShow,
    onSubmit: handleCreateBusinessUnit
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    className: "BusinessUnitsSection-FormLabel",
    column: true,
    md: labelColSpan
  }, t('business_units')), report.project_business_units.length === 0 && !displayOnly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    as: "select",
    size: "md",
    name: "businessUnitId",
    onChange: e => handleChange(e),
    type: "text",
    placeholder: "Small text",
    value: selectedBusinessUnit || ''
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }), pageAccess.canCreateNewBusinessUnit && /*#__PURE__*/React.createElement("option", {
    value: "0"
  }, t('create_new')), report.business_units.filter(bu => bu.state === 'active').filter(bu => report.project_business_units.every(pbu => pbu.business_unit.id !== bu.id)).sort((a, b) => a.name.localeCompare(b.name)).map(c => {
    return /*#__PURE__*/React.createElement("option", {
      key: c.id,
      value: c.id
    }, c.name);
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !selectedBusinessUnit || !pageAccess.canEditProjectDetails,
    variant: "link",
    onClick: submit
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add'))))), report.project_business_units.map((pbu, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BusinessUnitItem, {
      pbu: pbu,
      handleDelete: onRemove || handleDelete,
      key: index,
      pageAccess: pageAccess
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }));
};
export default BusinessUnitsSection;